import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import { Chat } from '~/components/chat/Chat.client';
import { apiGetProjects } from '~/lib/api/projects';
import { $activeProjectId, $activeProjectName } from '~/lib/stores/projects';
import { $isAuthenticated } from '~/lib/stores/auth';

export default function IndexPage() {
  const isAuthenticated = useStore($isAuthenticated);

  useEffect(() => {
    document.title = 'Dunea';

    if (!isAuthenticated) {
      return;
    }

    apiGetProjects()
      .then((projects) => {
        if (projects.length > 0) {
          $activeProjectId.set(projects[0].id);
          $activeProjectName.set(projects[0].name);
        }
      })
      .catch(() => {
        // ignore – projects will just not be set
      });
  }, [isAuthenticated]);

  return <Chat />;
}
